import { createContext } from 'react'

export const RuleEditorContext = createContext({
    elementID: null,

    showModal: () => {},
    hideModal: () => {},
})
